import React, { FC } from 'react'

import styled from 'styled-components'

import RightArrowIcon from 'src/Assets/Svg/pages-icons/RightArrow.svg?react'
import { IconButton } from 'src/Components/Buttons/IconButton'

const PromotionCard = styled.div<{ $highlighted?: boolean }>`
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: space-between;
  background-color: transparent;
  padding: 24px;
  border-radius: 16px;
  border: 1px solid
    ${({ theme, $highlighted }) =>
      $highlighted ? theme.color.brandGreen : theme.color.lightGrey};
  background: ${({ theme }) => theme.color.white};
  box-shadow: ${({ theme }) => theme.shadow.card};
  cursor: pointer;
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const Title = styled.h2`
  color: ${({ theme }) => theme.color.darkGrey};
  margin: 0 0 4px 0;
  font-family: 'Segoe UI';
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`

const Description = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.color.darkGrey};
  margin: 0 0 16px 0;
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`

const TagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

const Tag = styled.span<{ $highlighted?: boolean }>`
  background-color: ${({ theme, $highlighted }) =>
    $highlighted ? theme.color.lightGreen : theme.color.lightGrey};
  color: ${({ theme, $highlighted }) =>
    $highlighted ? theme.color.darkGreen : theme.color.darkGrey};
  height: 24px;
  display: flex;
  align-items: center;
  padding: 0px 6px;
  border-radius: 16px;
  overflow: hidden;
  text-overflow: ellipsis;

  font-family: 'Segoe UI';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`

type Props = {
  onClick: () => void
  tags: string[]
  title: string
  children?: React.ReactNode
  highlighted?: boolean
}

export const Promotion: FC<Props> = (props) => {
  const { onClick, tags, title, children, highlighted } = props

  return (
    <PromotionCard $highlighted={highlighted} onClick={onClick}>
      <ContentWrapper>
        <Title>{title}</Title>
        <Description>{children}</Description>
        <TagsWrapper>
          {tags.map((tag) => (
            <Tag $highlighted={highlighted} key={tag}>
              {tag}
            </Tag>
          ))}
        </TagsWrapper>
      </ContentWrapper>
      <IconButton>
        <RightArrowIcon />
      </IconButton>
    </PromotionCard>
  )
}
